import "./FsnbNrspNormBox.css";
import "./FsnbCoefBox.css";
import "./FsnbAutocomplete.css";

import { useEffect, useRef, useState } from "react";

import apiFsnb from "api/fsnb";
import AlertLoading from "components/AlertLoading";
import Table from "components/Table/Table";
import KsprButton from "components/UI/buttons/KsprButton";

import NormNrspConnectedColumns from "../TableSetting/NormNrspConnectedColumns";
import FsnbFilterVersSelect from "./FsnbFilterVersSelect";

export default function FsnbNrspNormBox(props) {
	const [tableData, setTableData] = useState([]);
	const scrollBlock = useRef(null);
	const [fetchStatus, setFetchStatus] = useState(null);
	const [fetchStatusText, setFetchStatusText] = useState("");
	const [fsnbVersArr, setFsnbVersArr] = useState([]);
	const [selectedFsnbVers, setSelectedFsnbVers] = useState({});
	const columnsData = NormNrspConnectedColumns();

	/*eslint-disable */
	useEffect(() => {
		setFetchStatus("loading");
		apiFsnb
			.getFsnbVersionsInterPeriod(props.vers.id)
			.then((response) => {
				setFsnbVersArr(response.data);
				setSelectedFsnbVers(response.data[0]);
			})
			.then((data) => {
				setFetchStatus("success");
			})
			.catch((error) => {
				console.error(error);
				setFetchStatus("failed");
				if (error?.response?.data?.detail != null) {
					setFetchStatusText(error.response.data.detail);
				} else {
					setFetchStatusText(error);
				}
			});
	}, []);

	useEffect(() => {
		if (selectedFsnbVers.id == null) return;
		setFetchStatus("loading");
		apiFsnb
			.getNormOnNrsp(selectedFsnbVers.id, props.row.id)
			.then((response) => {
				setTableData(response.data);
			})
			.then((data) => {
				setFetchStatus("success");
			})
			.catch((error) => {
				console.error(error);
				setFetchStatus("failed");
				if (error?.response?.data?.detail != null) {
					setFetchStatusText(error.response.data.detail);
				} else {
					setFetchStatusText(error);
				}
			});
	}, [selectedFsnbVers]);
	/*eslint-enable */

	return (
		<div className="FsnbCoefBox FsnbNrspNormBox">
			<div className="FsnbCoefBoxHeader">
				<div className="FsnbCoefBoxHeaderLabel">Сметные нормативы1</div>
				{fsnbVersArr.length > 0 && (
					<div className="FsnbFilters">
						<FsnbFilterVersSelect
							label="Редакция ФСНБ"
							fsnbVersArr={fsnbVersArr}
							selectedFsnbVers={selectedFsnbVers}
							f_setSelectedFsnbVers={setSelectedFsnbVers}
						/>
					</div>
				)}
			</div>
			<div className="FsnbCoefBoxBody">
				{fsnbVersArr.length > 0 && (
					<div className="FsnbCoefTableLayout" ref={scrollBlock}>
						<Table
							rowData={tableData}
							columnsData={columnsData}
							scrollBlock={scrollBlock}
							options={{
								selectOptions: {
									controlled: true,
								},
								displayOptions: {
									displayScrollDelay: 20,
								},
							}}
							funcs={{
								setTableData: ({ newTableData }) => setTableData(newTableData),
							}}
						/>
						<div style={{ height: "5px" }}></div>
					</div>
				)}
			</div>
			<div className="FsnbCoefBoxFooter">
				<KsprButton variant="text" label="Закрыть" onClick={props.f_closeCoefBox} />
			</div>
			<AlertLoading fetchStatus={fetchStatus} fetchStatusText={fetchStatusText} func={setFetchStatus} />
		</div>
	);
}
